/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CompositeSearchEnhancedFilterType {
    JOB_FAMILY = 'jobFamily',
    JOB_SUB_FAMILY = 'jobSubFamily',
    JOB_LEVEL = 'jobLevel',
    GRADE = 'grade',
    TAG = 'tag',
    ELIGIBILITY1 = 'eligibility1',
    ELIGIBILITY2 = 'eligibility2',
    ELIGIBILITY3 = 'eligibility3',
    UDF_TEXT1 = 'udfText1',
    UDF_TEXT2 = 'udfText2',
    UDF_TEXT3 = 'udfText3',
    UDF_TEXT4 = 'udfText4',
    UDF_TEXT5 = 'udfText5',
    UDF_TEXT6 = 'udfText6',
    UDF_TEXT7 = 'udfText7',
    UDF_TEXT8 = 'udfText8',
    UDF_TEXT9 = 'udfText9',
    UDF_TEXT10 = 'udfText10',
    UDF_NUMBER1 = 'udfNumber1',
    UDF_NUMBER2 = 'udfNumber2',
    UDF_NUMBER3 = 'udfNumber3',
    UDF_NUMBER4 = 'udfNumber4',
    UDF_NUMBER5 = 'udfNumber5',
    UDF_NUMBER6 = 'udfNumber6',
    UDF_NUMBER7 = 'udfNumber7',
    UDF_NUMBER8 = 'udfNumber8',
    UDF_NUMBER9 = 'udfNumber9',
    UDF_NUMBER10 = 'udfNumber10',
    UDF_DATE1 = 'udfDate1',
    UDF_DATE2 = 'udfDate2',
    UDF_DATE3 = 'udfDate3',
}
